<template>
  <section
    :class="`h-[${height}rem] bg-[${imgUrl}]`"
    class="w-full bg-cover p-2 text-center lg:text-start flex justify-around flex-col sm:flex-row lg:justify-center items-center relative"
  >
    <slot> </slot>
    <div v-if="withFilter" class="absolute w-full h-full opacity-75 bg-gradient-to-br from-[#253170] to-[#3660B6]" />
  </section>
</template>

<script setup lang="ts">
interface TitleProps {
  height: number;
  imgUrl: string;
  withFilter: boolean;
}
// eslint-disable-next-line no-undef, @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<TitleProps>(), {
  height: 32, //Devido ao Tailwind é preciso definir os valores aceitos no arquivo de configuração do Tailwind, atualmente aceita 32 e 28
  imgUrl: '',
  withFilter: false,
});
</script>
